// extracted by mini-css-extract-plugin
module.exports = {"cover":"StickyElement_cover__1zU8R","stickyContainer":"StickyElement_stickyContainer__6M1ct","innerContainer":"StickyElement_innerContainer__2NbZl"};